import { Stack } from '@mui/material';

import CustomerKnowledgeBase from '../../components/customer/knowledgeBase/customerKnowledgeBase';

const CustomerKnowledgeBasePage = () => {
  return (
    <Stack>
      <CustomerKnowledgeBase />
    </Stack>
  );
};

export default CustomerKnowledgeBasePage;
